<template>
    <div>
        <vc-left-menu></vc-left-menu>

        <div :class="{ 'layout-content': true, 'is-active': !getMenuToggle }">
            <div class="page-header-container">
                <div class="page-header">
                    <h3 class="page-title">{{ $t('words.statistics_manage')}}<span class="page-header-breadcrumb">></span>{{ $t('words.statistics_service_logs')}}</h3>
                    <div class="page-header-action-group"><a class="btn" :href="getExportUrl"><i class="icon icon-download"></i>{{ $t('words.statistics_download') }}</a></div>
                </div>
                <div class="page-sub-header clearfix">
                    <div class="form-inline float-left">
                        <div class="control-group">
                            <label for="select_division" class="sr-only">{{ $t('words.division')}}</label>
                            <select id="select_division" :data-placeholder="$t('words.division')" style="width: 300px;">
                                <option :value="division" v-for="division in divisions" :key="division">
                                    {{ division === ''? $t('words.all') : $t(`words.${division}`) }}
                                </option>
                            </select>
                        </div>
                    </div>
                    <!--<form class="pull-right" @submit.prevent="doSearch">-->
                        <!--<label class="sr-only" for="keyword">{{ $t('words.search') }}</label>-->
                        <!--<input type="text" id="keyword" class="form-control" :placeholder="$t('paragraphs.placeholder_search')" v-model="keyword">-->
                    <!--</form>-->

                    <div class="module-action-group float-right">
                        <div class="btn-group btn-group__date">
                            <button :class="{'btn': true, 'active': (period==='1d')}" @click="changePeriod('1d')">{{ $t('words.period_today') }}</button>
                            <button :class="{'btn': true, 'active': (period==='3d')}" @click="changePeriod('3d')">{{ $t('words.period_3d') }}</button>
                            <button :class="{'btn': true, 'active': (period==='7d')}"  @click="changePeriod('7d')">{{ $t('words.period_7d') }}</button>
                            <button :class="{'btn': true, 'active': (period==='30d')}"  @click="changePeriod('30d')">{{ $t('words.period_30d') }}</button>
                        </div>
                        <div class="input-group input-group-date input-daterange" id="date-range">
                            <div class="input-group">
                                <vue-date-picker
                                    v-model="rangeDay"
                                    value-type="format"
                                    format="YYYY-MM-DD"
                                    range
                                    placeholder="Select date range"
                                    :disabled-date="notRangedDate"
                                >
                                </vue-date-picker>
                            </div>
                            <div class="input-group-append">
                                <button type="button" :class="{'btn': true, 'btn-icon': true, 'active':(period==='custom')}" @click.prevent="doSearch"><i class="icon icon-search"></i></button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="module">
                <div class="module-header">
                    <nav aria-label="Page navigation" class="ml-auto">
                        <ul class="pagination">
                            <li class="page-info">
                                <span>
                                    {{ $t('paragraphs.page_navigation', { total: serviceLogs.meta.total, from: ((serviceLogs.meta.current_page - 1) * serviceLogs.meta.per_page + 1), to: (serviceLogs.meta.current_page === serviceLogs.meta.last_page ? serviceLogs.meta.total : serviceLogs.meta.per_page * serviceLogs.meta.current_page )}) }}
                                </span>
                            </li>
                            <li :class="{'page-item': true, disabled: !serviceLogs.links.prev }">
                                <button class="page-link" aria-label="Previous" @click="loadServiceLogs(serviceLogs.links.prev)" v-if="serviceLogs.links.prev">
                                    <i class="icon icon-arrow-left-sm" aria-hidden="true"></i>
                                    <span class="sr-only">{{ $t('pagination.previous') }}</span>
                                </button>
                                <button class="page-link" aria-label="Previous" v-else>
                                    <i class="icon icon-arrow-left-sm" aria-hidden="true"></i>
                                    <span class="sr-only">{{ $t('pagination.previous') }}</span>
                                </button>
                            </li>
                            <li :class="{'page-item': true, disabled: !serviceLogs.links.next }">
                                <button class="page-link" aria-label="Next" @click="loadServiceLogs(serviceLogs.links.next)" v-if="serviceLogs.links.next">
                                    <i class="icon icon-arrow-right-sm" aria-hidden="true"></i>
                                    <span class="sr-only">{{ $t('pagination.next') }}</span>
                                </button>
                                <button class="page-link disabled" aria-label="Previous" disabled v-else>
                                    <i class="icon icon-arrow-right-sm" aria-hidden="true"></i>
                                    <span class="sr-only">{{ $t('pagination.next') }}</span>
                                </button>
                            </li>
                        </ul>
                    </nav>
                </div>
                <div class="module-body module-body-table">
                    <table class="table table-wide">
                        <thead>
                        <tr>
                            <th>{{ $t('words.action_datetime')}}</th>
                            <th>{{ $t('words.division')}}</th>
                            <th>{{ $t('words.action_user')}}</th>
                            <th>{{ $t('words.subject_name') }}</th>
                            <th>{{ $t('words.action_message')}}</th>
                        </tr>
                        </thead>
                        <tbody v-if="load && (serviceLogs.meta.total !== 0)">
                        <tr v-for="serviceLog in serviceLogs.data" :key="serviceLog.id">
                            <td class="td__date">{{ serviceLog.created_at | renderDateTime }}</td>
                            <td>{{ serviceLog.action }}</td>
                            <td>{{ serviceLog.user_name }}</td>
                            <td><span class="list__channel__name is-wide" v-tooltip="{ content: serviceLog.subject_name, html:false }">{{ serviceLog.subject_name }}</span></td>
                            <td>{{ serviceLog.message }}</td>
                        </tr>
                        </tbody>
                        <tbody v-else-if="load">
                        <tr>
                            <td colspan="5" class="td__message">
                                <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 24 24" class="svg-icon svg-icon-alert-circle"><g stroke-linecap="square" stroke-linejoin="miter" stroke-width="2" fill="#adb5bd" stroke="#adb5bd"><circle fill="none" stroke="#adb5bd" stroke-miterlimit="10" cx="12" cy="12" r="11"/> <line data-color="color-2" fill="none" stroke-miterlimit="10" x1="12" y1="7" x2="12" y2="13"/> <circle data-color="color-2" data-stroke="none" cx="12" cy="17" r="1" stroke-linejoin="miter" stroke-linecap="square" stroke="none"/></g></svg>{{ $t('paragraphs.list_empty') }}</td>
                        </tr>
                        </tbody>
                        <tbody v-else>
                        <tr>
                            <td colspan="5" class="td__message"><div class="loader"></div>{{ $t('paragraphs.list_loading') }}</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import GlobalConfigMixin from '../mixin/GlobalConfigMixin';
import DateTimeMixin from '../mixin/DateTimeMixin';
import 'selectize';
import VueDatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';

export default {
    mixins: [
        GlobalConfigMixin,
        DateTimeMixin,
    ],
    components: {
        VueDatePicker,
    },
    data() {
        return {
            selectedDivision: '',
            keyword: '',
            startDayLimit: '',
            endDayLimit: '',
            rangeDay: [],
            startDay: '',
            endDay: '',
            startDate: '',
            endDate: '',
            period: '',
            load: false,
            serviceLogs: {
                links: {
                    prev: null,
                    next: null,
                },
                data: [],
                meta: {
                    last_page: 0,
                    current_page: 1,
                    total: 0,
                    per_page: 0,
                },
            },
            divisions: [
                '',
                'all',
                'user_login',
                'creator_login',
                'channel_created',
                'channel_updated',
                'channel_restored',
                'channel_trashed',
                'channel_deleted',
                'broadcast_started',
                'broadcast_paused',
                'broadcast_resumed',
                'broadcast_stopped',
                'recording_file_download',
                'statistics_channel_download',
                'statistics_viewer_env_download',
                'statistics_service_log_download',
                'statistics_storage_usage_download',
                'duplicate_recording_start',
                'duplicate_recording_stop',
                'channel_disabled',
                'channel_enabled',
            ],
        };
    },
    mounted() {
        const self = this;
        $('#select_division').selectize({
            maxItems: 1,
            create: true,
            // sortField: 'text',
            onChange(value) {
                self.selectedDivision = value;
            },
        });
        if (this.loadedServiceAccount) {
            this.initialize();
        }
    },
    methods: {
        initialize() {
            this.initSelectableDate('1y');
            this.changePeriod('1d');
        },
        doSearch() {
            this.setUtcStartEndDateTime();
            this.period = 'custom';

            this.loadServiceLogs(this.serviceLogsApi);
        },
        changePeriod(period) {
            this.extractRangeDayFromPeriod(period);
            this.setUtcStartEndDateTime();

            this.loadServiceLogs(this.serviceLogsApi);
        },
        loadServiceLogs(serviceLogsApi) {
            const self = this;
            self.load = false;
            axios.get(serviceLogsApi).then((response) => {
                self.serviceLogs = response.data;
                self.load = true;
            });
        },
    },
    computed: {
        channelApi() {
            return `/cms/${this.selectedServiceAccount.key}/channels/${this.selectedChannel}`;
        },
        broadcastApi() {
            return `${this.channelApi}/broadcasts/${this.selectedBroadcast}`;
        },
        statisticsApi() {
            return `/cms/${this.selectedServiceAccount.key}/statistics`;
        },
        serviceLogsApi() {
            return `${this.statisticsApi}/service_logs?division=${this.selectedDivision}&start_date=${this.startDate}&end_date=${this.endDate}&timezone=${window.Laravel.tz}&keyword=${this.keyword}`;
        },
        getExportUrl() {
            return `${this.statisticsApi}/export_service_log?division=${this.selectedDivision}&start_date=${this.startDate}&end_date=${this.endDate}&timezone=${window.Laravel.tz}&keyword=${this.keyword}`;
        },
    },
    watch: {
        loadedServiceAccount(newValue) {
            this.initialize();
        },
        selectedDivision() {
            this.loadServiceLogs(this.serviceLogsApi);
        },
    },
};
</script>
